import { Action } from "@ngrx/store";

export const SET_NEWS_SEARCH_TEXT = "set_news_search_text";
export const GET_NEWS_SEARCH_TEXT = "get_news_search_text";

export const GET_NEWS = "get_news";
export const GET_NEWS_SUCCESS = "get_news_success";

export const GET_NEWS_BY_ID = "get_news_by_id";
export const GET_NEWS_BY_ID_SUCCESS = "get_news_by_id_success";

export const GET_RSS_NEWS = "get_rss_news";
export const GET_RSS_NEWS_SUCCESS = "get_rss_news_success";

export const GET_NEWS_ERROR = "get_news_error";

export const UPDATE_NEWS_SUCCESS = "update_news_success";

export class SetNewsSearchTextAction implements Action {
  readonly type = SET_NEWS_SEARCH_TEXT;
  constructor(public payload: string) {}
}

export class GetNewsAction implements Action {
  readonly type = GET_NEWS;
  constructor(
    public url: string,
    public all: boolean = true,
    public published: boolean = false,
  ) {}
}

export class GetNewsSuccessAction implements Action {
  readonly type = GET_NEWS_SUCCESS;
  constructor(public payload: any) {}
}

export class GetNewsByIdAction implements Action {
  readonly type = GET_NEWS_BY_ID;
  constructor(
    public id: string,
    public published: boolean = false,
  ) {}
}

export class GetNewsByIdSuccessAction implements Action {
  readonly type = GET_NEWS_BY_ID_SUCCESS;
  constructor(public payload: any) {}
}

export class GetRssNewsAction implements Action {
  readonly type = GET_RSS_NEWS;
  constructor() {}
}

export class GetRssNewsSuccessAction implements Action {
  readonly type = GET_RSS_NEWS_SUCCESS;
  constructor(public payload: any) {}
}

export class GetNewsErrorAction implements Action {
  readonly type = GET_NEWS_ERROR;
  constructor(public payload: any) {}
}

export class UpdateNewsSuccessAction implements Action {
  readonly type = UPDATE_NEWS_SUCCESS;
  constructor(public payload: any) {}
}

export type All =
  | SetNewsSearchTextAction
  | GetNewsAction
  | GetNewsSuccessAction
  | GetNewsByIdAction
  | GetNewsByIdSuccessAction
  | GetNewsErrorAction
  | GetRssNewsAction
  | GetRssNewsSuccessAction
  | UpdateNewsSuccessAction;
